import { render, staticRenderFns } from "./NoEmailAlert.vue?vue&type=template&id=66c0ee56"
import script from "./NoEmailAlert.vue?vue&type=script&lang=js"
export * from "./NoEmailAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports